// src/components/elite/EliteBadge.js
import React from "react";

export default function EliteBadge({ size = "sm", showLabel = true }) {
  const base =
    "inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-yellow-400 via-amber-300 to-yellow-500 text-black font-semibold";
  const sizes = {
    sm: "px-2 py-0.5 text-[10px]",
    md: "px-2.5 py-1 text-xs",
    lg: "px-3 py-1 text-sm",
  };

  return (
    <span className={`${base} ${sizes[size] || sizes.sm}`}>
      <span className="text-xs leading-none">👑</span>
      {showLabel && <span>Elite</span>}
    </span>
  );
}